import { IArticleCardData, IArticleCard, IArticleCardAction } from 'models/magazine/article/articlecard';
import { IStore } from 'redux/IStore';

/** Action Types */
export const REQUEST_NEXT_ARTICLE_START: string = 'similararticles/REQUEST_NEXT_ARTICLE_START';
export const REQUEST_NEXT_ARTICLE_FAILURE: string = 'similararticles/REQUEST_NEXT_ARTICLE_START';
export const GET_NEXT_ARTICLE_SUCCESS: string = 'similararticles/GET_NEXT_ARTICLE_SUCCESS';

/** Initial State */
const initialState: IArticleCardData = {
	item: null,
	isFetching: false,
};

/** Reducer */
export function nextArticleReducer(state = initialState, action: IArticleCardAction) {
	switch (action.type) {
		case REQUEST_NEXT_ARTICLE_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_NEXT_ARTICLE_SUCCESS:
			return Object.assign({}, state, {
				item: action.payload.item,
				isFetching: false,
			});

		case REQUEST_NEXT_ARTICLE_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getNextArticle(code: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/' + code + '/Next',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IArticleCard) => {
						dispatch(getNextArticleSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => dispatch(requestFailure(err)));
	};
}

/** Action Creator */
export function requestStart(): IArticleCardAction {
	return {
		type: REQUEST_NEXT_ARTICLE_START,
	};
}

/** Action Creator */
export function getNextArticleSuccess(item: IArticleCard): IArticleCardAction {
	return {
		type: GET_NEXT_ARTICLE_SUCCESS,
		payload: {
			item,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IArticleCardAction {
	return {
		type: REQUEST_NEXT_ARTICLE_FAILURE,
		payload: {
			message,
		},
	};
}
